if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class CustomDropdown extends HTMLElement {
  constructor() {
    super();
  }
  get value() {
    return this.wrapper.querySelector("[data-trigger]").innerHTML;
  }
  get selectedChoice() {
    return (
      Array.from(this.choices).filter((c) => {
        return c.innerHTML.trim() == this.value.trim();
      })?.[0] || null
    );
  }
  connectedCallback() {
    this.wrapper = this.querySelector("[data-wrapper]");
    this.choices = this.querySelectorAll("[data-dropdown] label");
    this.arrow = this.wrapper.children[1];
    this.optionsContainer = this.wrapper.children[2];
    this.event = new Event("change");

    this.initListeners();
  }
  initListeners() {
    this.wrapper.addEventListener("click", this.handleClick.bind(this));
    window.addEventListener("click", this.handleOutsideClick.bind(this));
    this.choices.forEach((choice) =>
      choice.addEventListener("click", this.handleChoiceSelection.bind(this))
    );
  }
  handleChoiceSelection(e) {
    if (
      this.wrapper.querySelector("[data-trigger]").innerHTML !=
      e.target.innerHTML
    ) {
      this.wrapper.querySelector("[data-trigger]").innerHTML =
        e.target.innerHTML;
      this.dispatchEvent(this.event);
    }
  }
  handleClick(e) {
    if (this.wrapper.classList.contains("active")) {
      this.handleDropdown(false);
    } else {
      this.handleDropdown(true);
    }
  }
  handleOutsideClick(e) {
    if (e.target.closest("[data-wrapper]") === null) {
      this.closeDropdown();
    }
  }
  handleDropdown(open) {
    if (open) {
      this.arrow.classList.add("rotated");
      this.wrapper.classList.add("active");
    } else {
      this.arrow.classList.remove("rotated");
      this.wrapper.classList.remove("active");
    }
  }
  closeDropdown() {
    this.handleDropdown(false);
  }
}
if (!customElements.get("custom-dropdown")) {
  customElements.define("custom-dropdown", CustomDropdown);
}
